import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-subtle">
      <div className="text-center space-y-4">
        <h1 className="mb-4 text-4xl font-bold bg-clip-text text-transparent gradient-primary">{t("notfound.title")}</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t("notfound.message")}</p>
        <a href="/" className="text-primary underline hover:opacity-80 transition-opacity">
          {t("notfound.home")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
